const AWS_URL = '//s3-us-west-2.amazonaws.com/static.studiesweekly.com/';
const CDN_URL = '//cdn.studiesweekly.com/';

const convertCdnUrlToAWS = (url) => {
    return url.replace(CDN_URL, AWS_URL);
};

export { convertCdnUrlToAWS, AWS_URL, CDN_URL };
